export enum API_ERROR
{
    COULD_NOT_GET_ACCESS_TOKEN = "Could not get access token"
}